export default __webpack_public_path__ + "static/media/sounds/ES_TRO_Instructions_For_Questions.mp3";